import polyglotI18nProvider from 'ra-i18n-polyglot';
import messages from '../i18n';

const getMessages = locale => (locale === 'en' ? messages["en"] : messages["fr"]);

const I18nProvider = polyglotI18nProvider(
    getMessages,
    'fr' // Default locale
);

export const getTranslatedFieldValues = (key, masterKey?) => {
    const i18n = getMessages(I18nProvider.getLocale()).resources;
    let values;
    if (masterKey) {
        values = (i18n[masterKey] && i18n[masterKey][key]) || i18n[key];
    } else {
        values = i18n[key];
    }
    return values;
};

export default I18nProvider;